import React, { useRef } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';

const selectStyles = {
  height: '2.5rem',
  fontSize: '0.875rem',
};

const selectMenuProps = {
  PaperProps: {
    sx: {
      '& .MuiMenuItem-root': {
        fontSize: '0.875rem',
      },
    },
  },
};

const TIMEFRAME_OPTIONS = [
  { label: '1 hour', hours: 1 },
  { label: '5 hours', hours: 5 },
  { label: '12 hours', hours: 12 },
  { label: '24 hours', hours: 24 },
];

const SELECT_BLUR_DELAY_IN_MILLISECONDS = 0;

export default function TimeframeSelector({ hoursTimeframe, onTimeframeChange }) {
  const selectRef = useRef(null);

  const handleChange = (event) => {
    onTimeframeChange(event.target.value);
    
    setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.blur();
      }
      document.activeElement.blur();
    }, SELECT_BLUR_DELAY_IN_MILLISECONDS);
  };

  const handleClose = () => {
    if (selectRef.current) {
      selectRef.current.blur();
    }
    document.activeElement.blur();
  };

  return (
    <FormControl sx={{ mt: -0.5, mb: 0.2, width: 'fit-content' }}>
      <Select
        ref={selectRef}
        value={hoursTimeframe}
        onChange={handleChange}
        onClose={handleClose}
        sx={selectStyles}
        MenuProps={selectMenuProps}
      >
        {TIMEFRAME_OPTIONS.map((option) => (
          <MenuItem key={option.hours} value={option.hours}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}